import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .hasRegion()
    .hasTitle()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

export default schema;
